import { WCConnector } from "./WCConnector";
import { LegacyConnector } from "./legacyConnector";
import { getBladeExtension, waitForConnector } from "./helpers/interfaceHelpers";
import { ExtensionConnector } from "./extensionConnector";
export class BladeSigner {
    constructor(meta) {
        this.isInitialized = async () => {
            var _a, _b;
            if (this.connector instanceof ExtensionConnector) {
                const extensionInterface = await getBladeExtension();
                if (extensionInterface && typeof extensionInterface.wake === "function") {
                    return await extensionInterface.wake() && Boolean((_a = this.connector) === null || _a === void 0 ? void 0 : _a.initialized);
                }
            }
            return Boolean((_b = this.connector) === null || _b === void 0 ? void 0 : _b.initialized);
        };
        getBladeExtension().then(extensionInterface => {
            if (!extensionInterface) {
                this.connector = new WCConnector(meta);
                return;
            }
            if (typeof extensionInterface.pairWC === "function") {
                this.connector = new ExtensionConnector(meta);
                return;
            }
            this.connector = new LegacyConnector();
        }).catch(() => {
            this.connector = new WCConnector(meta);
            return;
        });
    }
    async selectAccount(accountId) {
        await waitForConnector(this.isInitialized);
        return this.connector.selectAccount(accountId);
    }
    onAccountChanged(callback) {
        waitForConnector(this.isInitialized).then(() => {
            this.connector.onAccountChanged(callback);
        });
    }
    onWalletLocked(callback) {
        waitForConnector(this.isInitialized).then(() => {
            this.connector.onWalletLocked(callback);
        });
    }
    async createSession(params) {
        await waitForConnector(this.isInitialized);
        return this.connector.createSession(params);
    }
    async killSession() {
        await waitForConnector(this.isInitialized);
        return this.connector.killSession();
    }
    getNetwork() {
        var _a;
        return ((_a = this.connector) === null || _a === void 0 ? void 0 : _a.getNetwork()) || {};
    }
    getMirrorNetwork() {
        var _a;
        return ((_a = this.connector) === null || _a === void 0 ? void 0 : _a.getMirrorNetwork()) || [];
    }
    async sign(messages, signOptions) {
        await waitForConnector(this.isInitialized);
        return this.connector.sign(messages, signOptions);
    }
    async signTransaction(transaction) {
        await waitForConnector(this.isInitialized);
        return this.connector.signTransaction(transaction);
    }
    async call(request) {
        await waitForConnector(this.isInitialized);
        return this.connector.call(request);
    }
    async checkTransaction(transaction) {
        await waitForConnector(this.isInitialized);
        return this.connector.checkTransaction(transaction);
    }
    async populateTransaction(transaction) {
        await waitForConnector(this.isInitialized);
        return this.connector.populateTransaction(transaction);
    }
    getLedgerId() {
        var _a;
        return ((_a = this.connector) === null || _a === void 0 ? void 0 : _a.getLedgerId()) || null;
    }
    getAccountId() {
        var _a;
        return (_a = this.connector) === null || _a === void 0 ? void 0 : _a.getAccountId();
    }
    async getAccountBalance() {
        await waitForConnector(this.isInitialized);
        return this.connector.getAccountBalance();
    }
    async getAccountInfo() {
        await waitForConnector(this.isInitialized);
        return this.connector.getAccountInfo();
    }
    async getAccountRecords() {
        await waitForConnector(this.isInitialized);
        return this.connector.getAccountRecords();
    }
    get initialized() {
        return Boolean(this.connector);
    }
}
